import '@mxa-argos/core/config/i18n';

import App from '@mxa-argos/App';
import React from 'react';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />,
  </React.StrictMode>,
);
